import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="panel">
      <h2>Page not found</h2>
      <p className="subtle">
        That route doesn't exist. <Link to="/">Return to the dashboard</Link>.
      </p>
    </section>
  );
}
